import { Injectable } from '@angular/core';
import { Router} from "@angular/router";
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import getMAC, { isMAC } from 'getmac'
import { environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private BASE_URL: string = environment.API_URL;
  private BASE_URL_PHP: string = environment.PHP_API;
  private errorData: any = {};
  //usersLoginData:any = JSON.parse(localStorage.getItem('userLoginPass') || '[]');
  usersLoginData1:any = JSON.parse(localStorage.getItem('adminLoginPass') || '[]');

 // username: string = this.usersLoginData.email; password: string = this.usersLoginData.pass;
  username1: string = this.usersLoginData1.email; password1: string = this.usersLoginData1.pass;
 // authorizationData :any= 'Basic ' + btoa(this.username + ':' + this.password);
  authorizationData1 :any= 'Basic ' + btoa(this.username1 + ':' + this.password1);



  constructor(private http: HttpClient, private router: Router) {}
  // httpOptions1 = {
  //   headers: new HttpHeaders({ 'Authorization': this.authorizationData})
  // };
  httpOptions2 = {
    headers: new HttpHeaders({ 'Authorization': this.authorizationData1})
  };


   /**********Create Module Assessemnt Detail************/
  //  assessmentReport(startDate:any,endDate:any): Observable<any>{
  //   return this.http.post(this.BASE_URL+'user/view-userassisment-detail',{ "fromdate" : startDate,"todate":endDate},this.httpOptions1);
  //  }
  assessmentReport(startDate:any,endDate:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/view-userassisment-detail',{ "fromdate" : startDate,"todate":endDate},this.httpOptions2);
   }
  seperateAssessmentReport(startDate:any,endDate:any): Observable<any>{
    return this.http.post(this.BASE_URL+'report/seprate/assessment ',{ "fromdate" : startDate,"todate":endDate},this.httpOptions2);
   }
  organisationReport(): Observable<any>{
    return this.http.post(this.BASE_URL+'organisation-report',{},this.httpOptions2);
  }
  courseReport(): Observable<any>{
    return this.http.post(this.BASE_URL+'course-report',{},this.httpOptions2);
  }
  setting(accountValidity:any,multipalLogins:any): Observable<any>{
    return this.http.post(this.BASE_URL+'user/update_setting',{"accountValidity":accountValidity,"multipalLogins":multipalLogins},this.httpOptions2);
  }
  settingData(): Observable<any>{
    return this.http.post(this.BASE_URL+'user/get_setting',{},this.httpOptions2);
  }
  lastLoginRepost(user_id:any): Observable<any>{
    return this.http.get(this.BASE_URL+'user/lastlogin',this.httpOptions2);
  }
}
